export enum ButtonTypes {
  Primary = 'primary',
  Secondary = 'secondary',
  Success = 'success',
  Danger = 'danger',
  Outlined = 'outlined',
}
